import { ANALYTICS_PATH } from "@workspace/analytics/constants";
import posthog from "posthog-js";
import { env } from "@/env";

posthog.init(env.NEXT_PUBLIC_POSTHOG_KEY, {
  api_host: ANALYTICS_PATH,
  ui_host: "https://us.posthog.com",
  defaults: "2026-01-30",
  autocapture: true,
  capture_pageleave: true,
  rageclick: true,
  disable_surveys: true,
  disable_session_recording: false,
  logs: {
    captureConsoleLogs: true,
  },
  session_recording: {
    sampleRate: 1,
  },
  prepare_external_dependency_script: (script) => {
    if (script.src.includes("posthog-recorder.js")) {
      script.src = `${ANALYTICS_PATH}/static/record.js`;
    }
    return script;
  },
});
